import './HeroSubtitle.css'

const HeroSubtitle = () => {
  return (
    <p className="hero__subtitle">
      Fast, lightweight and 100% safe
    </p>
  )
}

export default HeroSubtitle
